module.exports = __webpack_public_path__ + "static/Clarip-ddd82d901f8409437e7424278ef101aa.jpg";